import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotificacao } from "../context/NotificacaoContext";
import "../assets/styles/Page.css";
import CampoLogin from "../components/common/CampoLogin";

function Cadastro() {
  const navigate = useNavigate();
  const { login, signup, userExists } = useAuth();
  const { mostrarNotificacao } = useNotificacao();

  const [isLogin, setIsLogin] = useState(true);
  const [form, setForm] = useState({ nome: "", identificador: "", senha: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLogin) {
      try {
        await login({ identificador : form.identificador });
        mostrarNotificacao("Login realizado", "success");
        navigate("/dashboard");

      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            mostrarNotificacao("Ops! Tivemos um problema no servidor. Tente novamente em instantes.", "error");
            return;
          } else {
            mostrarNotificacao(err.response.data?.message || "Erro no login", "error");
          }
        }
        mostrarNotificacao("Falha de conexão", "error");
      }
      
    } else {
      try {
        var user = await userExists(form.identificador);
        if (!user)
        {
          await signup(form);
          mostrarNotificacao("Usuário cadastrado!", "success");
        }
     
        if (user.Empresa)
          navigate("/dashboard");

        navigate("/company");

      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            mostrarNotificacao("Ops! Tivemos um problema no servidor. Tente novamente em instantes.", "error");
            return;
          } else {
            mostrarNotificacao(err.response.data?.message || "Erro no cadastro", "error");
          }
        }
        mostrarNotificacao("Falha de conexão", "error");
      }
    }
  };

  return (
    <div className="page">
      <div className="page-box">
        <h2>{isLogin ? "Login" : "Cadastro"}</h2>
        <h3>{isLogin ? "" : "Informe seus dados"}</h3>
        <form onSubmit={handleSubmit}>
          {!isLogin && (
            <input
                type="text"
                placeholder="Nome"
                value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                required
            />
          )}
          <CampoLogin
            onChange={(dados) => setForm({ ...form, identificador: dados.valor })}
          />
          <input
            type="password"
            placeholder="Senha"
            value={form.senha}
            onChange={(e) => setForm({ ...form, senha: e.target.value })}
            required
          />
          <button type="submit">{isLogin ? "Entrar" : "Cadastrar"}</button>
        </form>
        <p className="toggle-form"
           onClick={() => setIsLogin(!isLogin)} >
            {isLogin ? "Não tem conta? Cadastre-se" : "Já tem conta? Faça login"}
        </p>
        </div>
    </div>
  );
}

export default Cadastro;
